import React from 'react';
import { Button } from './Button';
export function Hero() {
  return <section className="flex flex-col gap-3 md:gap-8 pt-4 md:pt-12 pb-6 md:pb-8 min-h-[100svh] md:min-h-0 justify-between md:justify-start" data-id="element-54">
      <div className="flex flex-col gap-3 md:gap-8" data-id="element-55">
        <p className="text-center text-[10px] md:text-base font-bold uppercase tracking-wider text-[#D97757] bg-[#D97757]/10 border border-[#D97757]/30 rounded-full py-1.5 md:py-3 px-3 md:px-5 self-center" data-id="element-56">
          Si sos fonoaudióloga psicopedagoga o neurolingüista esto es para vos
        </p>

        <h1 className="font-serif text-lg md:text-4xl lg:text-5xl text-[#0F4C3A] font-bold leading-tight text-center flex flex-col gap-2 md:gap-4 px-2" data-id="element-57">
          <span data-id="element-58">
            ¿Son las 12 de la noche y todavía estás preparando la sesión de
            mañana?
          </span>
        </h1>

        <p className="text-base md:text-2xl font-bold text-[#D97757] text-center" data-id="element-59">
          Eso se termina hoy.
        </p>

        <div className="flex flex-col gap-2 md:gap-4 text-center" data-id="element-60">
          <h2 className="text-sm md:text-2xl font-bold text-stone-800 px-2" data-id="element-61">
            Sistema Integral de Intervención en Tartamudez, Disfluencia y
            Disfemia™
          </h2>
        </div>
      </div>

      <div className="flex flex-col gap-3 md:gap-6 md:mt-4" data-id="element-62">
        <a href="#compra" className="flex flex-col w-full cursor-pointer hover:opacity-95 transition-opacity" data-id="element-63">
          <img src="https://cdn.magicpatterns.com/uploads/eWafe8SkQTpsLSNG1QCt98/WhatsApp_Image_2026-05-11_at_3.58.56_PM-removebg-preview.png" alt="Sistema Integral de Intervención" className="w-full h-auto object-contain max-h-[34vh] md:max-h-none mx-auto" data-id="element-64" />
        </a>

        <div className="flex flex-col gap-1 md:gap-4 text-center" data-id="element-65">
          <p className="text-xs md:text-lg text-stone-600 leading-snug px-2" data-id="element-66">
            540 fichas clínicas organizadas por diagnóstico, edad y objetivo.
            Listas para imprimir y usar desde el primer día.
          </p>
          <p className="text-[11px] md:text-base font-medium text-stone-700" data-id="element-67">
            Pago único de $19.990 ARS · Descarga inmediata
          </p>
        </div>

        <Button href="#compra" className="!py-3 md:!py-5 !text-sm md:!text-lg" data-id="element-68">
          QUIERO EL SISTEMA AHORA →
        </Button>
      </div>
    </section>;
}